module.exports = __webpack_public_path__ + "static/media/children-learning.3cfd8ea9.svg";